<template>
    <div class="group-box">
        <component v-for="(btn,i) in btns" :key="i" :is="btn.component" :btn="btn" class="ad-btn" :page="page" :style="btn.style"></component>
    </div>
</template>

<script>

import CComp from '@/components/Cards/Comp';
import CImage from '@/components/Cards/Image'
import CLink from '@/components/Cards/Link';
import CQr from '@/components/Cards/Qr'
import CRotate from '@/components/Cards/Rotate'
import CTerms from '@/components/Cards/Terms'
import CText from '@/components/Cards/Text'
import CVideo from '@/components/Cards/Video';
import CBox from '@/components/Cards/Box'
import Card  from '@/components/Card.vue';
import CButton from '@/components/Cards/Button.vue'
import CStamp from '@/components/Cards/CStamp.vue'
import CQrRefer from '@/components/Cards/QrRefer.vue'
import CWallet from '@/components/Cards/CWallet'
import CQuill from '@/components/Cards/CQuill'
import CInput from '@/components/Cards/CInput'
import CGroup from '@/components/Cards/CGroup'

export default {
    props: ['btn','page'],
    components: {
        CComp,
        CImage,
        CLink,
        CQr,
        CRotate,
        CTerms,
        CText,
        CVideo,
        CBox,
        CStamp,
        CButton,
        CQrRefer,
        CWallet,
        CQuill,
        CInput,
    },
    data () {
        return {
            btns: [],
            style: ''
        }
    },
    mounted () {
        var btn = this.btn;
        this.btns = btn.btns;
        this.style = btn.style+'font-size:'+btn.fontSize+'px;color:'+btn.fontColor;
        //console.log('this.$el',this.$el);
        //console.log('btn.style',btn.style);
        //console.log('this.style',this.style)
        btn.style = this.style;
    },
    methods: {
        keyUp ( e ) {

        }
    }
}    
</script>

